import { useQuery } from '@tanstack/react-query';

import type { Shops } from '@/Swagger';
import { aimsApi } from '@/axios/AclosetApi';
import type { UseAxiosQueryOptions } from '@/utils/typeHelper';

import { 서비스_가격목록_쿼리키 } from './query-keys';

type QueryOptions = UseAxiosQueryOptions<Shops.ServicePricingsList.ResponseBody, typeof 서비스_가격목록_쿼리키.all>;

/**
 * 서비스 가격 목록을 리스트로 조회합니다.
 * @see https://kr-api-dev.acloset.net/shops/swagger/index.html#/Settlements/get_shops_service_pricings
 */
export function useServicesPricingsQuery(option?: Omit<QueryOptions, 'queryFn' | 'queryKey'>) {
  return useQuery({
    queryKey: 서비스_가격목록_쿼리키.all,
    queryFn: () => {
      return aimsApi.shops.servicePricingsList().then(v => v.data);
    },
    ...option,
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: 1000 * 60 * 60 * 24,
    retry: 3,
  });
}
